<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 19:51:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceModiReason\newAttendanceModiReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-06 15:00:01
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceModifiReason_form_newTitle')"
    widthClass="max-1000"
    :initData="ReasonData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'attendance_modification_reason_name',
      'sequence',
      'attendance_modification_reason_description',
      'attendance_modification_reason_code',
      'remarks',
    ]"
  >
    <template v-slot:page-main>
      <v-form lazy-validation ref="form">
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ReasonData.attendance_modification_reason_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  ReasonData.attendance_modification_reason_name = valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_attendanceModifiReason_form_attendancModifiReasonLabel'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
            Type
            <v-select
              :items="ReasonType"
              item-text="type_uuid"
              item-value="uuid"
              filled
              :menu-props="{ offsetY: true,transition:'slide-y-transition',rounded:true,contentClass:'elevation-4' }"
              single-line
              v-model="ReasonData.type_uuid"
              label="Type"
              dense
            >
          <template v-slot:no-data>
            <noContent />
          </template></v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="
                $t('label_essweb_attendanceModifiReason_form_sequenceLabel')
              "
              maxlength="255"
              type="number"
              isNotRequire
              v-model="ReasonData.sequence"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              v-model="ReasonData.attendance_modification_reason_code"
              maxlength="50"
              :label="$t('label_essweb_attendanceModifiReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ReasonData.attendance_modification_reason_description"
              @change="
                (valueArr) => {
                  ReasonData.attendance_modification_reason_description =
                    valueArr;
                }
              "
              maxlength="500"
              :label="
                $t('label_essweb_attendanceModifiReason_form_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiReason_form_remakLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              dense
              filled
              counter="500"
              single-line
              v-model="ReasonData.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newAttendanceModiReason",
  computed: {
    ...mapGetters(["companyLang"]),
    TypeList() {
      return this.$getSelectTrans(this.TypeData, "type_name");
    },
  },
  data() {
    return {
      search: "",
      isChanged: false,
      ReasonData: {
        attendance_modification_reason_name: "",
        // type_uuid: "",
        sequence: 1,
        attendance_modification_reason_description: "",
        attendance_modification_reason_code: "",
        remarks: "",
      },
      TypeData: [],
    };
  },
  mounted() {
    // this.ReasonData.attendance_modification_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.ReasonData.attendance_modification_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
  },
  methods: {
    // getType: function () {
    //   this.$Request({
    //     method: "POST",
    //     table: "",
    //     url: "",

    //   }).then((res) => {
    //     that.TypeData = res.data;
    //   });
    // },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/add/",
        data: {
          attendance_modification_reason_name: this.$transCommonLangKey(
            this.ReasonData.attendance_modification_reason_name
          ),
          attendance_modification_reason_description: this.$transCommonLangKey(
            this.ReasonData.attendance_modification_reason_description
          ),
          attendance_modification_reason_code:
            this.ReasonData.attendance_modification_reason_code,
          sequence: this.ReasonData.sequence,
          remarks: this.ReasonData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
